import React from "react";
import styles from "./styles/Licence.module.css";

export default class Licence extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.bg}>
        <pre>
          <code>
            {`
            本软件尊重并保护所有使用服务用户的个人隐私权。
        为了给您提供更准确、更有个性化的服务，本软件会按照
        本隐私权政策的规定使用和披露您的个人信息。但本软件
        将以高度的勤勉、审慎义务对待这些信息。除本隐私权政
        策另有规定外，在未征得您事先许可的情况下，本软件不
        会将这些信息对外披露或向第三方提供。本软件会不时更
        新本隐私权政策。您在同意本软件服务使用协议之时，即
        视为您已经同意本隐私权政策全部内容。本隐私权政策属
        于本软件服务使用协议不可分割的一部分。

        1.适用范围
            a)在您使用本软件网络服务，本软件自动接收并记
            录的您的手机上的信息，包括但不限于您的健康数
            据、使用的语言、访问日期和时间、软硬件特征信
            息及您需求的网页记录等数据；

        2.信息的使用
            a)在获得您的数据之后，本软件会将其上传至服务
            器，以生成您的排行榜数据，以便您能够更好地使
            用服务。

        3.信息披露
            a)本软件不会将您的信息披露给不受信任的第三方。
            b)根据法律的有关规定，或者行政或司法机构的要求，
        向第三方或者行政、司法机构披露；
            c)如您出现违反中国有关法律、法规或者相关规则的
            情况，需要向第三方披露；

        4.信息存储和交换
            本软件收集的有关您的信息和资料将保存在本软件及
            （或）其关联公司的服务器上，这些信息和资料可能
            传送至您所在国家、地区或本软件收集信息和资料所
            在地的境外并在境外被访问、存储和展示。

        5.信息安全
            a)在使用本软件网络服务进行网上交易时，您不可避
            免的要向交易对方或潜在的交易对方披露自己的个人
            信息，如联络方式或者邮政地址。请您妥善保护自己
            的个人信息，仅在必要的情形下向他人提供。如您发
            现自己的个人信息泄密，请您立即联络本软件客服，
            以便本软件采取相应措施。
    `}
          </code>
        </pre>
      </div>
    );
  }
}
